export default __webpack_public_path__ + "static/media/neto.10e232f5.png";